export const SELF_SERVE_STEP_PATHNAMES = ['/reserve/1', '/reserve/2', '/reserve/3'];

export const OLD_ALL_ACCESS_FREE_TRIAL_PLAN_REF = 'all_access';
export const ALL_ACCESS_FREE_TRIAL_PLAN_REF = 'aa';
export const ALL_ACCESS_FREE_TRIAL_PLAN_REFS = [OLD_ALL_ACCESS_FREE_TRIAL_PLAN_REF, ALL_ACCESS_FREE_TRIAL_PLAN_REF];

export const RESERVABLE_TYPES = {
  hotDesk: 'HotDesk',
  dedicatedDesk: 'DedicatedDesk',
  sharedOfficeDesk: 'SharedOfficeDesk',
  office: 'Office',
  allAccess: 'AllAccess'
};

export const PRODUCT_TYPES = {
  HOT_DESK: 'hot_desk',
  ALL_ACCESS_FREE_TRIAL: 'all_access',
  STANDARD_ALL_ACCESS: 'standard_all_access',
  SAKSWORKS: 'saksworks'
};

export const RESERVABLE_TYPE_TO_MESSAGE = {
  [RESERVABLE_TYPES.hotDesk]: 'hotDesk',
  [RESERVABLE_TYPES.allAccess]: 'allAccess',
  [RESERVABLE_TYPES.dedicatedDesk]: 'dedicatedDesk',
  [RESERVABLE_TYPES.sharedOfficeDesk]: 'dedicatedDesk',
  [RESERVABLE_TYPES.office]: 'privateOffice'
};

export const MARKET_FILTER_DATE_VALUES = {
  thisMonth: 'this_month',
  nextMonth: 'next_month',
  other: 'other'
};

export const MAX_DAYS_AWAY_TO_ALLOW_MOVE_IN = 42;

export const AMENITIES = {
  mailAndPackaging: 'mailAndPackaging',
  privateOfficeConferenceRoomCredits: 'privateOfficeConferenceRoomCredits',
  deskConferenceRoomCredits: 'deskConferenceRoomCredits',
  printingCredits: 'printingCredits',
  furnished: 'furnished'
};

export const FLOORPLAN_ASSET_BASE_URL = 'https://www-floorplan-assets.imgix.net';

export const ALL_ACCESS_PRODUCT_UUID = 'ca04dfa5-b8f4-4c80-b36e-f9547a23f654';
export const ALL_ACCESS_FREE_TRIAL_PRODUCT_UUID = '46b2785e-ff00-4401-82c7-31009328448b';
export const SAKSWORKS_PRODUCT_UUID = '494cd758-db87-4e0d-b9c3-2adfd9199c7e';

export const CHECKOUT_PRODUCTS_UUID_MAP = new Map(
  Object.entries({
    standard_all_access: ALL_ACCESS_PRODUCT_UUID,
    aa: ALL_ACCESS_FREE_TRIAL_PRODUCT_UUID,
    saksworks: SAKSWORKS_PRODUCT_UUID
  })
);

export const ALL_ACCESS_COUNTRY_ALLOWLIST = [
  'US',
  'GB',
  'FR',
  'IT',
  'ES',
  'DE',
  'SE',
  'CA',
  'NO',
  'PL',
  'CZ',
  'AU',
  'BR',
  'AE',
  'NL',
  'SG',
  'MX',
  'BE',
  'IE'
];

export const HOT_DESK_DEPRECATED_COUNTRIES = [
  'CA',
  'GB',
  'US',
  'IT',
  'ES',
  'DE',
  'IE',
  'BE',
  'FR',
  'SE',
  'NO',
  'PL',
  'MX',
  'BR',
  'NL',
  'AU',
  'CZ',
  'SG',
  'AE'
];

export const LOOKUP__COUNTRY_ISO_TO_BILLING_ENTITY = {
  GB: 'dcb693ea-78d2-4a11-bbf4-11130b3122bf', // Great Britain Billing Entity
  CA: '712d2193-390a-4148-8ff4-61809c82b931', // Canada Billing Entity
  FR: '3e18355f-a805-4732-a8fd-30f206492a5d', // France Billing Entity
  BR: 'c798451b-84fd-4f0f-9307-e219103b3f60', // Brazil Billing Entity
  MX: '51813a1a-8f9c-488c-9901-084963fd9d4b', // Mexico Billing Entity
  DE: '29874470-e555-457c-8637-0b346ae83c4d', // Germany (Friesenplatz 4) Billing Entity
  US: 'cec7a8c2-4a49-4db0-8b89-53c80e2fa83a', // United States Billing Entity
  IE: 'f4d12c39-2a7e-4db1-8744-a39ab2dd99b2', // Ireland (Central Plaza) Billing Entity
  BE: 'c3120f74-984f-42f8-b962-84e6ebf5f5b6', // Belgium Billing Entity
  IT: 'ba036459-5585-4d7f-9dd5-526bfd9aaf5d', // Italy Billing Entity
  ES: '22498409-bd4d-4986-8242-526a24ef543d', // Spain Billing Entity
  AU: 'c76e2865-675b-4bbc-b59e-d07634b94ad6', // Australia Billing Entity
  SE: '3c615c11-7541-47bd-ba96-52437abe4cda', // Sweden Billing Entity
  PL: 'b14fded3-ca54-4008-8b1c-3e661c6c61bd', // Poland Billing Entity
  CZ: '35702c37-903c-44bb-8440-a2bf7ecc930f', // Czech Republic Billing Entity
  NO: '1241a0c5-e9ee-4eec-9671-b75c2b49b75e', // Norway Billing Entity
  NL: 'a4c7df90-5318-0132-ea50-2261d352f8c5', // Netherlands Billing Entity
  SG: '70c8793d-f3cc-4698-b204-d8df3b36a170', // Singapore Billing Entity
  AE: '8d774f7b-ce6f-4247-ad94-e9c9cbf89514' // United Arab Emirates Billing Entity
};

export const LOOKUP__COUNTRY_ISO_TO_UUID = {
  GB: 'a72000e4-1ea7-11e6-ab4a-0a488af3e541', // United Kingdom Country UUID
  CA: 'a64938f2-1ea7-11e6-ab4a-0a488af3e541', // Canada Country UUID
  FR: '0f1274fe-22d9-11e6-8807-0a488af3e541', // France Country UUID
  BR: '85634b04-31b8-11e6-85d9-0a488af3e541', // Brazil Country UUID
  MX: 'a44de3c2-1ea7-11e6-ab4a-0a488af3e541', // Mexico UUID
  DE: 'a52254cc-1ea7-11e6-ab4a-0a488af3e541', // Germany UUID
  US: 'a4620adc-1ea7-11e6-ab4a-0a488af3e541', // United States UUID
  IE: '88be8502-31b8-11e6-85d9-0a488af3e541', // Ireland UUID
  BE: '84ce6a0c-31b8-11e6-85d9-0a488af3e541', // Belgium UUID
  IT: '891a94b4-31b8-11e6-85d9-0a488af3e541', // Italy UUID
  ES: '8713da5e-31b8-11e6-85d9-0a488af3e541', // Spain UUID
  AU: '64acbbf0-2922-11e6-bdd3-0a488af3e541', // Australia UUID
  SE: '8d525580-31b8-11e6-85d9-0a488af3e541', // Sweden UUID
  PL: '8c731456-31b8-11e6-85d9-0a488af3e541', // Poland UUID
  CZ: '868cac3c-31b8-11e6-85d9-0a488af3e541', // Czech Republic UUID
  NO: '8bc409de-31b8-11e6-85d9-0a488af3e541', // Norway UUID
  NL: 'a5c40dee-1ea7-11e6-ab4a-0a488af3e541', // Netherlands UUID
  SG: '8d5f19b4-31b8-11e6-85d9-0a488af3e541', // Singapore UUID
  AE: '83c1b916-31b8-11e6-85d9-0a488af3e541', // United Arab Emirates UUID
  IN: '88dc74c2-31b8-11e6-85d9-0a488af3e541', // India UUID
  JP: '894cc1b4-31b8-11e6-85d9-0a488af3e541', // Japan UUID
  KR: 'a435352a-1ea7-11e6-ab4a-0a488af3e541', // South Korea UUID
  ZA: '8fe14fe0-31b8-11e6-85d9-0a488af3e541', // South Africa UUID
  PH: '8c58a1fc-31b8-11e6-85d9-0a488af3e541', // Philippines UUID
  TH: '8e628e2c-31b8-11e6-85d9-0a488af3e541', // Thailand UUID
  ID: '88b0dc86-31b8-11e6-85d9-0a488af3e541', // Indonesia UUID
  MY: '8b5c3728-31b8-11e6-85d9-0a488af3e541', // Malaysia UUID
  VN: '8f80e5a6-31b8-11e6-85d9-0a488af3e541', // Vietnam UUID
  CO: '8630e08c-31b8-11e6-85d9-0a488af3e541', // Colombia UUID
  CL: '86134d1a-31b8-11e6-85d9-0a488af3e541', // Chile UUID
  AR: '844ed29c-31b8-11e6-85d9-0a488af3e541', // Argentina UUID
  PE: '8c2b35aa-31b8-11e6-85d9-0a488af3e541' // Peru UUID
};

export const COOKIE_KEYS = {
  returnTo: 'returnTo',
  WE_ACCESS_TOKEN: 'we_access_token'
};

export const HIDDEN_CLASS = 'hidden';
